import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '../tooltip/tooltip.module';
import { IconModule } from '../icon/icon.module';

// imports
import { CodeSnippet } from './code-snippet.component';

// exports
export {
  CodeSnippet,
  SnippetLanguage,
  SnippetType,
} from './code-snippet.component';

@NgModule({
  declarations: [
    CodeSnippet,
  ],
  exports: [
    CodeSnippet,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    IconModule,
  ]
})
export class CodeSnippetModule { }
